package feature.address.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class Address(
    @SerialName("UniqueID") var UniqueID: Long = 0,
    @SerialName("_id") var _id: String? = null,
    @SerialName("UserID") var UserID: String? = null,
    @SerialName("FeatureObjectID") var FeatureObjectID: String? = null,
    @SerialName("Name") var Name: String? = null,
    @SerialName("ZipCode") var ZipCode: Int? = null,
    @SerialName("Country") var Country: String? = null,
    @SerialName("State") var State: String? = null,
    @SerialName("City") var City: String? = null,
    @SerialName("Area") var Area: String? = null,
    @SerialName("LandMark") var LandMark: String? = null,
    @SerialName("House") var House: String? = null,
    @SerialName("FlatNumber") var FlatNumber: String? = null,
    @SerialName("Floor") var Floor: String? = null,
    @SerialName("MobileNumber") var MobileNumber: String? = null,
    @SerialName("Type") var Type: String? = null,
    @SerialName("Location") var Location: JsonObject? = null,
    @SerialName("IsPrimary") var IsPrimary: Boolean? = null,
    @SerialName("IsDeleted") var IsDeleted: Boolean? = null,
    @SerialName("CreatedAt") var CreatedAt: String? = null,
    @SerialName("UpdatedAt") var UpdatedAt: String? = null,
    @SerialName("__v") var _v: Int? = null
)
